/** CSS class for composite score text color by PFRA category tier. */
export function scoreBandClass(
  cat?: string | null,
  composite?: number | string | null,
): string {
  const fromCat = catToScoreBand(cat)
  if (fromCat) return fromCat
  const n = typeof composite === 'string' ? parseFloat(composite) : composite
  if (n == null || !Number.isFinite(n)) return ''
  if (n >= 90) return 'score-band--excellent'
  if (n >= 75) return 'score-band--satisfactory'
  return 'score-band--unsatisfactory'
}

export function catToScoreBand(cat: string | null | undefined): string {
  const c = (cat || '').toUpperCase().trim()
  if (!c) return ''
  if (c === 'EXCELLENT' || c.startsWith('EXC')) return 'score-band--excellent'
  if (c === 'SATISFACTORY' || c.startsWith('SAT')) return 'score-band--satisfactory'
  if (c === 'UNSATISFACTORY' || c.startsWith('UNSAT') || c === 'POOR') return 'score-band--unsatisfactory'
  return ''
}